import {Component, inject, OnInit} from '@angular/core';
import {TextButton} from '../../../../shared/components/text-button/text-button.component';
import {TranslocoPipe, TranslocoService} from '@jsverse/transloco';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormControl, ReactiveFormsModule} from '@angular/forms';
import {MatInputModule} from '@angular/material/input';
import {MatIconModule} from '@angular/material/icon';
import {AuthenticationService} from '../../authentication.service';
import {VerifyDto} from '../../dtos/verify.dto';
import {MemoryService} from '../../../../core/services/memory.service';
import {LoginResponseDto} from '../../dtos/login-response.dto';
import {ErrorService} from '../../../../core/services/error.service';
import {HttpErrorResponse} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {take} from 'rxjs';

@Component({
  selector: 'app-verify',
  imports: [
    TextButton,
    TranslocoPipe,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule
  ],
  templateUrl: './verify-email-address.component.html',
  styleUrl: './verify-email-address.component.scss'
})
export class VerifyEmailAddressComponent implements OnInit {
  authenticationService: AuthenticationService = inject(AuthenticationService);
  memoryService: MemoryService = inject(MemoryService);
  translocoService = inject(TranslocoService);
  errorService = inject(ErrorService);
  error?: string;
  urlParameter?: string;
  verificationCode: FormControl = new FormControl('');

  constructor(private activatedRoute: ActivatedRoute, private router: Router, private snackBar: MatSnackBar) {
  }

  ngOnInit() {
    this.translocoService.selectTranslation().pipe(take(1)).subscribe(() => {
      this.urlParameter = this.activatedRoute.snapshot.queryParams['verificationCode'];
      if (this.urlParameter) {
        this.verificationCode.setValue(this.urlParameter);
        this.verify();
      }
    });
  }

  verify() {
    const verifyDto: VerifyDto = {verificationCode: this.verificationCode.value};

    this.authenticationService.verify(verifyDto).subscribe({
      next: (loginResponseDto: LoginResponseDto) => {
        this.error = undefined;
        this.memoryService.patientId = loginResponseDto.patientId;
        this.memoryService.accessToken = loginResponseDto.accessToken;
        this.snackBar.open(this.translocoService.translate('verification.succeeded'), 'OK', {
          duration: 3000,
          horizontalPosition: 'end',
          verticalPosition: 'bottom'
        });
        this.router.navigate(['/profile']);
      },
      error: (error: HttpErrorResponse) => {
        if (error.status === 400) {
          this.error = this.translocoService.translate('error.verificationCode');
          return;
        }

        this.error = undefined;
        this.errorService.handleError(error, this.translocoService.translate('error.title.verify'));
      }
    })
  }
}
